// src/pages/Signup.js
import React from "react";
import AuthForm from "../components/AuthForm";

const Signup = () => <AuthForm isLogin={false} />;
export default Signup;